<template>
  <el-select :value="valueTitle" :clearable="clearable" @clear="clearHandle" ref="treeSelect">
    <el-input class="selectInput" :placeholder="placeholder" v-model="filterText"></el-input>
    <el-option :value="valueTitle" :label="valueTitle" class="options">
      <el-tree
        id="tree-option"
        ref="selectTree"
        :accordion="accordion"
        :data="options"
        :props="props"
        :node-key="props.value"
        :default-expanded-keys="defaultExpandedKey"
        :filter-node-method="filterNode"
        @node-click="handleNodeClick"
      >
      </el-tree>
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'el-tree-select',
  props: {
    /* 配置项 */
    props: {
      type: Object,
      default: () => {
        return {
          // ID字段名
          value: 'id',
          // 显示名称
          label: 'name',
          // 子级字段名
          children: 'children'
        }
      }
    },
    /* 选项列表数据(树形结构的对象数组) */
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    /* 初始值 */
    value: {
      type: String,
      default: () => {
        return ''
      }
    },
    label: {
      type: String,
      defalut: () => {
        return ''
      }
    },
    /* 可清空选项 */
    clearable: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    /* 自动收起 */
    accordion: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    placeholder: {
      type: String,
      default: () => {
        return '检索关键字'
      }
    }
  },
  data: function () {
    return {
      filterText: '',
      valueId: this.value, // 初始值
      valueTitle: this.label,
      defaultExpandedKey: []
    }
  },
  mounted: function () {
    this.initScroll()
  },
  methods: {
    initHandler: function (_value, _valueTitle) {
      this.valueId = _value
      this.valueTitle = _valueTitle
      // 设置默认选中
      this.$refs.selectTree.setCurrentKey(this.valueId)
      // 设置默认展开
      this.defaultExpandedKey = [this.valueId]
    },
    // 初始化滚动条
    initScroll: function () {
      this.$nextTick(() => {
        let scrollWrap = document.querySelectorAll('.el-scrollbar .el-select-dropdown__wrap')[0]
        let scrollBar = document.querySelectorAll('.el-scrollbar .el-scrollbar__bar')
        scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;'
        scrollBar.forEach((ele) => (ele.style.width = 0))
      })
    },
    // 切换选项
    handleNodeClick: function (node) {
      this.valueTitle = node[this.props.label]
      this.valueId = node[this.props.value]
      this.$emit('getValue', this.valueId)
      this.defaultExpandedKey = []
      if (!node.children || !node.children.length) {
        // 录选择完选项不能收起
        this.$refs.treeSelect.blur()
      }
    },
    // 清除选中
    clearHandle: function () {
      this.valueTitle = ''
      this.valueId = null
      this.defaultExpandedKey = []
      this.clearSelected()
      this.$emit('getValue', null)
    },
    /* 清空选中样式 */
    clearSelected: function () {
      let allNode = document.querySelectorAll('#tree-option .el-tree-node')
      allNode.forEach((element) => element.classList.remove('is-current'))
    },
    filterNode: function (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    }
  },
  watch: {
    filterText (val) {
      this.$refs.selectTree.filter(val)
    }
  }
}
</script>
<style scoped>
  .el-scrollbar .el-scrollbar__view .el-select-dropdown__item{
    height: auto;
    max-height: 274px;
    padding: 0;
    overflow: hidden;
    overflow-y: auto;
  }
  .el-select-dropdown__item.selected{
    font-weight: normal;
  }
  ul li >>>.el-tree .el-tree-node__content{
    height:auto;
    padding: 0 20px;
  }
  .el-tree-node__label{
    font-weight: normal;
  }
  .el-tree >>>.is-current .el-tree-node__label{
    color: #409EFF;
    font-weight: 700;
  }
  .el-tree >>>.is-current .el-tree-node__children .el-tree-node__label{
    color:#606266;
    font-weight: normal;
  }
  .selectInput{
    padding: 0 5px;
    box-sizing: border-box;
  }
</style>
